import { Theme } from '@mui/material';
import { makeStyles } from '@mui/styles';

const useStyles = makeStyles((theme: Theme) => ({
  modalBackdrop: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    outline: 'none',
  },
  card: {
    width: '90%',
    maxWidth: 1200,
    maxHeight: '90vh',
    overflow: 'auto',
    borderRadius: 16,
    boxShadow: '0 20px 45px rgba(0, 0, 0, 0.2)',
  },
  content: {
    padding: '30px',
    display: 'flex',
    flexDirection: 'column',
    gap: '30px',
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  title: {
    fontWeight: 700,
    color: theme.palette.primary.main,
    fontSize: '25px',
    fontFamily: 'Montserrat',
  },
  closeButton: {
    padding: '4px',
    color: theme.palette.text.primary,
  },
  infoSection: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
    gap: '16px',
  },
  infoItem: {
    display: 'flex',
    flexDirection: 'column',
    gap: '4px',
  },
  label: {
    fontSize: '14px',
    fontWeight: 700,
    color: theme.palette.text.primary,
    fontFamily: 'Montserrat',
  },
  value: {
    fontSize: '14px',
    fontWeight: 400,
    color: theme.palette.text.primary,
    fontFamily: 'Montserrat',
  },
  mainSection: {
    display: 'flex',
    flexDirection: 'row',
    gap: '30px',
    '@media (max-width: 900px)': {
      flexDirection: 'column',
    },
  },
  imageWrapper: {
    flex: '2',
    minWidth: '300px',
    '@media (max-width: 900px)': {
      flex: '1',
      minWidth: 'auto',
    },
  },
  imageContainer: {
    borderRadius: 8,
    width: '100%',
    height: 'auto',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'relative',
    backgroundColor: theme.palette.grey[100],
    minHeight: '400px',
  },
  imageLoading: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
  },
  image: {
    width: '100%',
    height: 'auto',
    objectFit: 'contain',
    maxHeight: 600,
  },
  commentsWrapper: {
    flex: '1',
    minWidth: '250px',
    '@media (max-width: 900px)': {
      minWidth: 'auto',
    },
  },
  commentsSection: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    gap: '20px',
  },
  commentsTitle: {
    fontSize: '20px',
    fontWeight: 700,
    color: '#5BC2D5',
    fontFamily: 'Montserrat',
  },
  commentBox: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    gap: '20px',
  },
  commentLabel: {
    fontSize: '14px',
    fontWeight: 700,
    color: theme.palette.text.primary,
    fontFamily: 'Montserrat',
  },
  commentValue: {
    fontSize: 'clamp(13px, 0.85vw, 15px)',
    color: theme.palette.text.primary,
  },
  commentText: {
    fontSize: 'clamp(13px, 0.85vw, 15px)',
    color: theme.palette.text.primary,
    lineHeight: 1.6,
    marginTop: '4px',
    whiteSpace: 'pre-wrap',
    wordBreak: 'break-word',
  },
  noImageMessage: {
    textAlign: 'center',
    color: theme.palette.text.secondary,
    fontSize: '16px',
    fontFamily: 'Montserrat',
  },
}));

export default useStyles;
